import React from 'react';
import { Tooltip, Select, Checkbox, FormInstance, Form } from 'antd';
import { FirstLevelPermission, CiPermission, FormValues } from '../../types';
import { CI_PERMISSION_INFO, CI_PERMISSION_KEYS, FISRT_LEVEL_PERMISSION_INFO } from './utils';
import { QuestionCircleOutlined } from '@ant-design/icons';

const CiPermissionWithoutAdmin: CiPermission[] = CI_PERMISSION_KEYS.filter(
  (it) => it !== 'ciSegmentAdminPermission',
);
function getChanged(
  pre: CiPermission[],
  cur: CiPermission[],
): {
  action: 'check' | 'uncheck';
  permission?: CiPermission;
} | null {
  if (pre.length < cur.length) {
    const permission = cur.find((it) => !pre.includes(it));
    return {
      permission,
      action: 'check',
    };
  } else if (pre.length > cur.length) {
    const permission = pre.find((it) => !cur.includes(it));
    return {
      permission,
      action: 'uncheck',
    };
  }
  return null;
}
export const CiPermissionSelect = ({
  form,
  onCiPermissionChange,
}: {
  form: FormInstance<FormValues>;
  onCiPermissionChange: (values: string[]) => void;
}) => {
  const key: FirstLevelPermission = 'ciEnabled';
  const permissions = Form.useWatch('permissions', form) ?? [];
  const ciPermission = CI_PERMISSION_KEYS.filter((it) => permissions.includes(it));
  const ciEnabled = permissions.includes(key);
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        height: '24px',
      }}
    >
      <Checkbox
        value={key}
        style={{ fontWeight: 'normal' }}
        onChange={(evt) => {
          if (!evt.target.checked) {
            onCiPermissionChange([]);
          }
        }}
      >
        {FISRT_LEVEL_PERMISSION_INFO[key]}
      </Checkbox>
      {ciEnabled && (
        <Select
          size="small"
          placeholder="Select More Audience Permission"
          mode="multiple"
          maxTagCount="responsive"
          value={ciPermission}
          onChange={(value) => {
            const state = getChanged(ciPermission, value);
            let result = value;
            if (state && state.permission) {
              const { permission, action } = state;
              if (!permission) {
                return;
              }
              if (permission === 'ciSegmentAdminPermission' && action === 'check') {
                result = Array.from(new Set([...result, ...CiPermissionWithoutAdmin]));
              } else if (CiPermissionWithoutAdmin.includes(permission) && action === 'uncheck') {
                result = result.filter((it) => it !== 'ciSegmentAdminPermission');
              }
            }
            onCiPermissionChange(result);
          }}
        >
          {Object.entries(CI_PERMISSION_INFO).map(([key, value]) => {
            const { label, description } = value;
            return (
              <Select.Option value={key} key={key}>
                {label}
                <Tooltip title={description}>
                  <QuestionCircleOutlined />
                </Tooltip>
              </Select.Option>
            );
          })}
        </Select>
      )}
    </div>
  );
};
